import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  signal,
} from '@angular/core';

@Component({
  selector: 'c-button-loading',
  standalone: false,
  templateUrl: './button-loading.component.html',
  styleUrl: './button-loading.component.css',
})
export class ButtonLoadingComponent {
  @Input() isLoading = signal<boolean>(false);
  @Input() text = 'Ingresar';

  @Output() onClick = new EventEmitter();

  @HostListener('document:keydown.enter', ['$event' as any])
  handleEnter(event: KeyboardEvent) {
    if (!this.isLoading()) this.onClick.emit();
  }
}
